var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_c('span',[_vm._v(_vm._s(_vm._f("format")(_vm.lastTime)))]),_c('span',[_vm._v(_vm._s(_vm._f("format2")(_vm.lastTime)))]),_c('span',[_vm._v(_vm._s(_vm._f("format3")(_vm.lastTime)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }